// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__23jo5","rootSuccess":"CompleteLink_rootSuccess__3pThw","rootFailure":"CompleteLink_rootFailure__2jjIG","isDisabled":"CompleteLink_isDisabled__u2BRF"};